An externally hosted video to display alongside advertisement details.
